import { Routes, Route, Navigate } from "react-router-dom";
import { Register } from "../screens/Register/Register";
import { ResetPassword } from "../screens/ResetPassword/ResetPassword";
import Login from "../screens/Login/Login";

const OpenRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/register" element={Register}></Route>
      <Route path="/resetpassword" element={ResetPassword}></Route>
      <Route path="*" element={<Navigate to="/" />} /> {/* Redirect any unknown path to home */}
    </Routes>
  );
};

export default OpenRoutes;
